import { Subject } from 'rxjs';

const subject = new Subject();

export const orderFilterService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};